<div class="screening-error">
  <div>
    System Error: Failed to do screening

    <ul class="screening-error-list">
      <li *ngFor="let item of errorMessages">
        <div class="screening-error-list-name">
          <b>{{item.name}}</b>
        </div>
        <div class="screening-error-list-errors"><i>{{item.errors}}</i></div>
      </li>
    </ul>
  </div>
  <div class="mat-simple-snackbar-action screening-error-action">
    <button mat-button class="mat-button" (click)="close()">
      Dismiss
    </button>
  </div>
</div>
